<app-sent-message-list
[sentMessageList]="sentMessageList">
</app-sent-message-list>
<!-- <app-sent-message-list [sentMessageList]="sentMessageList" [isAdmin]="isAdmin"></app-sent-message-list> -->

